import { AppPagination, AppTable } from '@/components/atoms';
import { Insurer } from '@/types/admin-insurer';
import { Checkbox, Empty, TableProps } from 'antd';
import { SorterResult } from 'antd/es/table/interface';
import { EMPTY_TEXT_FILTERED } from '@/constants';

interface Meta {
  current_page: number;
  total: number;
}

interface Props {
  data: Insurer[];
  meta?: Meta;
  isLoading: boolean;
  selectedRowKeys: number[];
  sortBy?: string;
  order?: 'ascend' | 'descend' | null;
  pageSize: number;
  onSelectionChange: (keys: number[]) => void;
  onTableChange: (sorter: SorterResult<Insurer> | SorterResult<Insurer>[]) => void;
  onPageChange: (page: number) => void;
}

const AdminInsurerAttentionCreateTable = ({
  data,
  meta,
  isLoading,
  selectedRowKeys,
  sortBy,
  order,
  pageSize,
  onSelectionChange,
  onTableChange,
  onPageChange,
}: Props) => {
  const columns: TableProps<Insurer>['columns'] = [
    {
      title: '保険者番号',
      dataIndex: 'insurer_number_full',
      key: 'insurer_number',
      sorter: true,
      sortOrder: sortBy === 'insurer_number' ? order || undefined : undefined,
    },
    {
      title: '保険者名称',
      dataIndex: 'insurer_name',
      key: 'insurer_name',
      sorter: true,
      sortOrder: sortBy === 'insurer_name' ? order || undefined : undefined,
    },
    {
      title: '種別',
      key: 'insurer_type',
      render: (_: unknown, record: Insurer) => record.insurer_type?.name ?? '-',
    },
    {
      title: '都道府県',
      dataIndex: 'address1',
      key: 'address1',
    },
  ];

  const allSelected = data.length > 0 && selectedRowKeys.length >= data.length;

  return (
    <div className="bg-white rounded-md border">
      <AppTable
        columns={columns}
        dataSource={data}
        rowKey="id"
        rowSelection={{
          type: 'checkbox',
          selectedRowKeys,
          onChange: keys => onSelectionChange(keys as number[]),
          columnTitle: (
            <Checkbox
              checked={allSelected}
              onChange={e => {
                if (e.target.checked) {
                  onSelectionChange(data.map(r => r.id));
                } else {
                  onSelectionChange([]);
                }
              }}
            />
          ),
        }}
        onChange={(_p, _f, sorter) =>
          onTableChange(sorter as SorterResult<Insurer> | SorterResult<Insurer>[])
        }
        loading={isLoading}
        locale={{
          emptyText: (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={EMPTY_TEXT_FILTERED} />
          ),
        }}
        pagination={false}
      />
      <div className="flex justify-end p-4">
        <AppPagination
          current={meta?.current_page ?? 1}
          total={meta?.total ?? 0}
          pageSize={pageSize}
          onChange={onPageChange}
        />
      </div>
    </div>
  );
};

export default AdminInsurerAttentionCreateTable;
